import styleText from './as-panel.css?raw';

export class AsPanel extends HTMLElement {
  static readonly tag: string = 'as-panel';

  private static readonly _sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    this.shadowRoot.innerHTML = /*html*/`
      <slot></slot>
    `

    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsPanel._sheet
    ];
  }
}

// Check if the element is already defined before registering it
if (!customElements.get(AsPanel.tag)) {
  customElements.define(AsPanel.tag, AsPanel);
} else {
  console.warn("as-panel already defined");
} 
